(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["patikasso-cart-conversion-panel"] && !Shopify.designMode) return;
  try {
    if(!window.PatikassoCartConversionReady){
  window.PatikassoCartConversionReady=true;

  const panel=document.querySelector('[data-patikasso-cart-conversion]');
  if(panel){
    const OFFER_MS=15*60*1000;
    const TIMER_KEY='patikasso_first_order_offer_expiry';
    const CAMPAIGN_KEY='pkv3_offer_active_until';
    const CART_COMMITTED_KEY='patikasso_cart_offer_committed';
    const WA_ATTR='data-patikasso-wa-bottom';
    const COD_ATTR='data-patikasso-cod-hidden';
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const bar=panel.querySelector('.patikasso-cart-conversion__bar');
    const body=panel.querySelector('.patikasso-cart-conversion__body');
    const collapse=panel.querySelector('.patikasso-cart-conversion__collapse');
    const apply=panel.querySelector('[data-patikasso-apply-discount]');
    let lastAddSourceRect=null;
    let lastAddSourceTime=0;
    let lastAddButton=null;
    let lastAddedVariantId=null;
    let timerInterval=null;
    let emptying=false;

    const experimentControl=()=>Boolean(window.PatikassoExperiment?.isControl);

    const campaignActive=()=>{
      if(window.PatikassoCampaign?.isActive)return window.PatikassoCampaign.isActive();
      try{return Number(localStorage.getItem(CAMPAIGN_KEY)||0)>Date.now()}catch(e){return false}
    };

    const resetOfferButton=()=>{
      if(!apply)return;
      apply.disabled=false;
      apply.classList.remove('is-loading');
      const main=apply.querySelector('.patikasso-cart-conversion__apply-main');
      const sub=apply.querySelector('.patikasso-cart-conversion__apply-sub');
      if(main)main.textContent='İndirimi Uygula ve Ödemeye Geç';
      if(sub)sub.textContent='Patikasso indirimi tek sefer uygulanır →';
    };

    const pauseForCampaign=()=>{
      clearInterval(timerInterval);
      try{sessionStorage.removeItem(TIMER_KEY)}catch(e){}
      resetOfferButton();
    };

    if(campaignActive())pauseForCampaign();

    const wait=(ms)=>new Promise((resolve)=>setTimeout(resolve,ms));

    const captureAddButton=(button)=>{
      if(!(button instanceof HTMLElement))return;
      const rect=button.getBoundingClientRect();
      if(rect.width<20||rect.height<20)return;
      lastAddSourceRect={
        left:rect.left,
        top:rect.top,
        width:rect.width,
        height:rect.height,
        cx:rect.left+rect.width/2,
        cy:rect.top+rect.height/2
      };
      lastAddSourceTime=Date.now();
      lastAddButton=button;
    };

    document.addEventListener('pointerdown',(event)=>{
      const button=event.target.closest('product-form [type="submit"], .product-form [type="submit"]');
      if(button)captureAddButton(button);
    },true);

    document.addEventListener('submit',(event)=>{
      const form=event.target;
      if(!(form instanceof HTMLFormElement))return;
      const productForm=form.closest('product-form');
      if(!productForm)return;
      const button=productForm.querySelector('[type="submit"]');
      if(button)captureAddButton(button);
    },true);

    const formatMoney=(cents,currency)=>{
      try{
        return new Intl.NumberFormat('tr-TR',{
          style:'currency',
          currency:currency||'TRY',
          minimumFractionDigits:0,
          maximumFractionDigits:2
        }).format((Number(cents)||0)/100);
      }catch(error){
        return ((Number(cents)||0)/100).toFixed(2)+' TL';
      }
    };

    const getBaseTotal=(cart)=>{
      const items=Array.isArray(cart?.items)?cart.items:[];
      const sum=items.reduce((total,item)=>{
        const originalLine=Number(item?.original_line_price);
        if(Number.isFinite(originalLine)&&originalLine>=0)return total+originalLine;
        const originalUnit=Number(item?.original_price);
        const quantity=Math.max(0,Number(item?.quantity)||0);
        return total+(Number.isFinite(originalUnit)?originalUnit*quantity:0);
      },0);
      return sum||Number(cart?.original_total_price)||Number(cart?.total_price)||0;
    };

    const collectDiscountTitles=(cart)=>{
      const values=[];
      const push=(value)=>{
        if(value!==null&&value!==undefined&&value!=='')values.push(String(value));
      };
      (Array.isArray(cart?.cart_level_discount_applications)?cart.cart_level_discount_applications:[]).forEach((app)=>{
        push(app?.title);
        push(app?.description);
      });
      (Array.isArray(cart?.items)?cart.items:[]).forEach((item)=>{
        const allocations=[
          ...(Array.isArray(item?.line_level_discount_allocations)?item.line_level_discount_allocations:[]),
          ...(Array.isArray(item?.discount_allocations)?item.discount_allocations:[])
        ];
        allocations.forEach((allocation)=>{
          push(allocation?.discount_application?.title);
          push(allocation?.discount_application?.description);
          push(allocation?.title);
          push(allocation?.description);
        });
      });
      return values;
    };

    const hasPatikassoDiscount=(cart)=>{
      return collectDiscountTitles(cart).some((value)=>{
        const title=value.toLocaleLowerCase('tr-TR');
        return title.includes('patikassoilk10')||
          title.includes('patikasso ilk')||
          title.includes('ilk sipariş')||
          title.includes('hoş geldin');
      });
    };

    const setOpen=(open)=>{
      if(open)window.PatikassoAnalytics?.track?.('cart_offer_opened','cart',{});
      panel.classList.toggle('is-open',open);
      if(bar)bar.setAttribute('aria-expanded',open?'true':'false');
      if(body)body.setAttribute('aria-hidden',open?'false':'true');
      if(open){
        panel.classList.remove('is-price-animating');
        requestAnimationFrame(()=>requestAnimationFrame(()=>panel.classList.add('is-price-animating')));
      }
    };

    const manageExternalWidgets=(visible)=>{
      const whatsapp=document.querySelectorAll('a[href*="wa.me"],a[href*="whatsapp"],[class*="whatsapp" i],[id*="whatsapp" i]');
      whatsapp.forEach((element)=>{
        if(!(element instanceof HTMLElement))return;
        if(visible){
          if(!element.hasAttribute(WA_ATTR)){
            element.setAttribute(WA_ATTR,element.style.bottom||'__none__');
          }
          element.style.setProperty('bottom','84px','important');
          element.style.setProperty('z-index','2147482990','important');
        }else if(element.hasAttribute(WA_ATTR)){
          const oldValue=element.getAttribute(WA_ATTR);
          if(oldValue==='__none__')element.style.removeProperty('bottom');
          else element.style.bottom=oldValue||'';
          element.removeAttribute(WA_ATTR);
        }
      });

      const candidates=document.querySelectorAll('button,a,[role="button"],[style*="position: fixed"],[style*="position:fixed"]');
      candidates.forEach((element)=>{
        if(!(element instanceof HTMLElement)||panel.contains(element))return;
        const text=(element.textContent||'').trim().toLocaleLowerCase('tr-TR');
        if(!text.includes('kapıda ödeme'))return;
        const style=getComputedStyle(element);
        if(style.position!=='fixed'&&style.position!=='sticky')return;
        if(visible){
          if(!element.hasAttribute(COD_ATTR)){
            element.setAttribute(COD_ATTR,element.style.display||'__none__');
          }
          element.style.setProperty('display','none','important');
        }else if(element.hasAttribute(COD_ATTR)){
          const oldValue=element.getAttribute(COD_ATTR);
          if(oldValue==='__none__')element.style.removeProperty('display');
          else element.style.display=oldValue||'';
          element.removeAttribute(COD_ATTR);
        }
      });
    };

    window.PatikassoManageCartWidgets=manageExternalWidgets;

    const setVisible=(visible)=>{
      if(experimentControl()||campaignActive()||panel.dataset.patikassoFirstOrderEligible==='false')visible=false;
      if(visible&&panel.dataset.analyticsShown!=='1'){
        panel.dataset.analyticsShown='1';
        window.PatikassoAnalytics?.track?.('cart_offer_shown','cart',{});
      }
      panel.classList.toggle('is-visible',visible);
      document.body.classList.toggle('patikasso-cart-conversion-visible',visible);
      if(!visible)setOpen(false);
      manageExternalWidgets(visible);
    };

    const getExpiry=()=>{
      let expiry=Number(sessionStorage.getItem(TIMER_KEY)||0);
      if(!expiry){
        expiry=Date.now()+OFFER_MS;
        sessionStorage.setItem(TIMER_KEY,String(expiry));
      }
      return expiry;
    };

    const updateTimer=()=>{
      const remaining=Math.max(0,getExpiry()-Date.now());
      const totalSeconds=Math.ceil(remaining/1000);
      const minutes=Math.floor(totalSeconds/60);
      const seconds=totalSeconds%60;
      const value=String(minutes).padStart(2,'0')+':'+String(seconds).padStart(2,'0');

      panel.querySelectorAll('[data-patikasso-timer],[data-patikasso-timer-mini]').forEach((element)=>{
        element.textContent=value;
      });

      panel.classList.toggle('is-urgent',remaining>0&&remaining<=5*60*1000);

      if(remaining<=0){
        clearInterval(timerInterval);
        panel.classList.remove('is-urgent');
        // The underlying Shopify first-order discount has no expiry date.
        // Never block a checkout because a client-side presentation timer elapsed.
        panel.querySelectorAll('[data-patikasso-timer-mini]').forEach((element)=>{
          element.textContent='%10';
        });
        panel.querySelectorAll('[data-patikasso-timer]').forEach((element)=>{
          element.textContent='Devam ediyor';
        });
        resetOfferButton();
      }
    };

    const ensureTimer=()=>{
      clearInterval(timerInterval);
      getExpiry();
      updateTimer();
      timerInterval=setInterval(updateTimer,1000);
    };

    const renderCartItems=(cart)=>{
      const wrap=panel.querySelector('[data-patikasso-cart-items]');
      const count=panel.querySelector('[data-patikasso-cart-count]');
      if(!wrap)return;

      const items=Array.isArray(cart?.items)?[...cart.items]:[];
      if(count)count.textContent=(Number(cart?.item_count)||0)+' ürün';

      if(lastAddedVariantId){
        items.sort((a,b)=>{
          const aLatest=String(a.variant_id)===String(lastAddedVariantId)?1:0;
          const bLatest=String(b.variant_id)===String(lastAddedVariantId)?1:0;
          return bLatest-aLatest;
        });
      }

      wrap.replaceChildren();

      items.forEach((item)=>{
        const card=document.createElement('div');
        card.className='patikasso-cart-conversion__cart-item';

        const latest=lastAddedVariantId&&String(item.variant_id)===String(lastAddedVariantId);
        if(latest)card.classList.add('is-latest');

        const pic=document.createElement('div');
        pic.className='patikasso-cart-conversion__cart-image';

        const src=item.image||(item.featured_image&&item.featured_image.url);
        if(src){
          const img=document.createElement('img');
          img.src=src;
          img.alt=item.product_title||item.title||'Sepet ürünü';
          img.loading='lazy';
          pic.appendChild(img);
        }

        if(Number(item.quantity)>1){
          const qty=document.createElement('span');
          qty.className='patikasso-cart-conversion__cart-qty';
          qty.textContent='×'+item.quantity;
          pic.appendChild(qty);
        }

        const info=document.createElement('div');
        info.className='patikasso-cart-conversion__cart-info';

        const title=document.createElement('span');
        title.className='patikasso-cart-conversion__cart-title';
        title.textContent=item.product_title||item.title||'Ürün';
        info.appendChild(title);

        if(item.variant_title&&item.variant_title!=='Default Title'){
          const variant=document.createElement('span');
          variant.className='patikasso-cart-conversion__cart-variant';
          variant.textContent=item.variant_title;
          info.appendChild(variant);
        }

        if(latest){
          const added=document.createElement('span');
          added.className='patikasso-cart-conversion__cart-added';
          added.textContent='Eklendi';
          info.appendChild(added);
        }

        const remove=document.createElement('button');
        remove.type='button';
        remove.className='patikasso-cart-conversion__cart-remove';
        remove.textContent='×';
        remove.setAttribute('aria-label',(item.product_title||'Ürün')+' ürününü sepetten çıkar');
        remove.dataset.cartLineKey=item.key||'';

        card.append(pic,info,remove);
        wrap.appendChild(card);
      });
    };

    const updatePrices=(cart)=>{
      const baseTotal=getBaseTotal(cart);
      const currentCheckoutTotal=Number(cart?.total_price)||baseTotal;
      const alreadyDiscounted=hasPatikassoDiscount(cart);
      const discounted=alreadyDiscounted?currentCheckoutTotal:Math.round(baseTotal*.9);
      const savings=alreadyDiscounted
        ? Math.max(0,baseTotal-currentCheckoutTotal)
        : Math.max(0,baseTotal-discounted);

      panel.querySelectorAll('[data-patikasso-cart-total]').forEach((element)=>{
        element.textContent=formatMoney(baseTotal,cart?.currency);
      });

      panel.querySelectorAll('[data-patikasso-discounted-total]').forEach((element)=>{
        element.textContent=formatMoney(discounted,cart?.currency);
      });

      panel.querySelectorAll('[data-patikasso-savings]').forEach((element)=>{
        element.textContent=formatMoney(savings,cart?.currency);
      });

      const newLabel=panel.querySelector('.patikasso-cart-conversion__price-column--new span');
      if(newLabel){
        newLabel.textContent=alreadyDiscounted?'Patikasso indirimi uygulandı':'İlk sipariş indirimi geçerli olursa';
      }
    };

    const animatePanelEmpty=async()=>{
      if(emptying)return;
      emptying=true;
      panel.classList.add('is-emptying');
      await wait(reduceMotion?0:430);
      setVisible(false);
      panel.classList.remove('is-emptying');
      emptying=false;
    };

    const launchCartMorph=async()=>{
      if(reduceMotion||!lastAddSourceRect||Date.now()-lastAddSourceTime>5000){
        panel.classList.add('is-materialized');
        setTimeout(()=>panel.classList.remove('is-materialized'),430);
        return;
      }

      if(!bar)return;

      const start=lastAddSourceRect;
      const realButton=lastAddButton;
      const barRect=bar.getBoundingClientRect();
      if(!barRect.width||!barRect.height)return;

      const barStyle=getComputedStyle(bar);
      const orb=42;
      const startCx=start.cx;
      const startCy=start.cy;
      const orbLeft=startCx-orb/2;
      const orbTop=startCy-orb/2;
      const barCx=barRect.left+barRect.width/2;
      const barCy=barRect.top+barRect.height/2;
      const dx=barCx-startCx;
      const dy=barCy-startCy;
      const lift=Math.min(62,Math.max(24,Math.abs(dy)*.08));

      const overlay=document.createElement('div');
      overlay.className='patikasso-cart-fly';
      Object.assign(overlay.style,{
        left:start.left+'px',
        top:start.top+'px',
        width:start.width+'px',
        height:start.height+'px',
        borderRadius:'4px'
      });
      overlay.innerHTML='<span class="patikasso-cart-fly__tone"></span><span class="patikasso-cart-fly__shine"></span><span class="patikasso-cart-fly__label">✓</span>';
      document.body.appendChild(overlay);

      panel.classList.add('is-morphing');
      if(realButton)realButton.style.opacity='0';

      try{
        await overlay.animate([
          {
            left:start.left+'px',
            top:start.top+'px',
            width:start.width+'px',
            height:start.height+'px',
            borderRadius:'4px'
          },
          {
            left:orbLeft+'px',
            top:orbTop+'px',
            width:orb+'px',
            height:orb+'px',
            borderRadius:'999px'
          }
        ],{
          duration:290,
          easing:'cubic-bezier(.16,1,.3,1)',
          fill:'forwards'
        }).finished;

        overlay.getAnimations().forEach((animation)=>animation.cancel());
        Object.assign(overlay.style,{
          left:orbLeft+'px',
          top:orbTop+'px',
          width:orb+'px',
          height:orb+'px',
          borderRadius:'999px',
          transform:'none'
        });

        const tone=overlay.querySelector('.patikasso-cart-fly__tone');
        const shine=overlay.querySelector('.patikasso-cart-fly__shine');
        const label=overlay.querySelector('.patikasso-cart-fly__label');

        tone?.animate([{opacity:0},{opacity:1}],{
          duration:720,
          easing:'cubic-bezier(.2,.72,.2,1)',
          fill:'forwards'
        });

        shine?.animate([{opacity:.54},{opacity:0}],{
          duration:720,
          easing:'ease-out',
          fill:'forwards'
        });

        label?.animate([
          {opacity:0,transform:'scale(.7)',offset:0},
          {opacity:1,transform:'scale(1)',offset:.18},
          {opacity:1,transform:'scale(1)',offset:.68},
          {opacity:0,transform:'scale(.9)',offset:1}
        ],{
          duration:720,
          easing:'cubic-bezier(.16,1,.3,1)',
          fill:'forwards'
        });

        await overlay.animate([
          {offset:0,transform:'translate3d(0,0,0)'},
          {offset:.58,transform:'translate3d('+(dx*.72)+'px,'+((dy*.72)-lift)+'px,0)'},
          {offset:1,transform:'translate3d('+dx+'px,'+dy+'px,0)'}
        ],{
          duration:540,
          easing:'cubic-bezier(.2,.78,.18,1)',
          fill:'forwards'
        }).finished;

        overlay.getAnimations().forEach((animation)=>animation.cancel());

        const finalLeft=barCx-orb/2;
        const finalTop=barCy-orb/2;
        Object.assign(overlay.style,{
          left:finalLeft+'px',
          top:finalTop+'px',
          width:orb+'px',
          height:orb+'px',
          borderRadius:'999px',
          transform:'none'
        });

        await overlay.animate([
          {
            offset:0,
            left:finalLeft+'px',
            top:finalTop+'px',
            width:orb+'px',
            height:orb+'px',
            borderRadius:'999px'
          },
          {
            offset:.14,
            left:finalLeft+'px',
            top:finalTop+'px',
            width:orb+'px',
            height:orb+'px',
            borderRadius:'999px'
          },
          {
            offset:1,
            left:barRect.left+'px',
            top:barRect.top+'px',
            width:barRect.width+'px',
            height:barRect.height+'px',
            borderRadius:barStyle.borderRadius||'17px'
          }
        ],{
          duration:280,
          easing:'cubic-bezier(.16,1,.3,1)',
          fill:'forwards'
        }).finished;

        bar.style.opacity='0';
        panel.classList.remove('is-morphing');

        await Promise.all([
          bar.animate([{opacity:0},{opacity:1}],{
            duration:160,
            easing:'ease-out',
            fill:'forwards'
          }).finished,
          overlay.animate([{opacity:1},{opacity:0}],{
            duration:160,
            easing:'ease-out',
            fill:'forwards'
          }).finished
        ]);
      }catch(error){
      }finally{
        bar.style.opacity='';
        panel.classList.remove('is-morphing');
        overlay.remove();
        if(realButton)realButton.style.opacity='';
        lastAddButton=null;
        lastAddSourceRect=null;
      }
    };

    const updateFromCart=(cart,attention)=>{
      if(!cart)return;

      const itemCount=Number(cart.item_count)||0;
      panel.dataset.itemCount=String(itemCount);
      updatePrices(cart);
      renderCartItems(cart);

      if(experimentControl()){setVisible(false);return}

      if(campaignActive()){
        pauseForCampaign();
        setVisible(false);
        return;
      }

      if(itemCount>0){
        if(panel.dataset.analyticsEligible!=='1'){
          panel.dataset.analyticsEligible='1';
          window.PatikassoAnalytics?.track?.('cart_offer_eligible','cart',{cart_items:itemCount,cart_total:Number(cart.total_price||0)});
        }
        window.PatikassoAnalytics?.tagCart?.();
        if(emptying){
          emptying=false;
          panel.classList.remove('is-emptying');
        }
        setVisible(true);
        ensureTimer();
      }else if(panel.classList.contains('is-visible')){
        animatePanelEmpty();
      }else{
        setVisible(false);
      }

      if(attention&&itemCount>0){
        panel.classList.remove('is-attention','is-price-animating');
        launchCartMorph().then(()=>{
          requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
              panel.classList.add('is-attention');
              setOpen(true);
            });
          });
        });
      }
    };

    const refreshCart=(attention=false)=>{
      const base=(window.routes&&window.routes.cart_url)?window.routes.cart_url:'/cart';
      fetch(base+'.js',{
        credentials:'same-origin',
        headers:{Accept:'application/json'}
      })
      .then((response)=>response.ok?response.json():Promise.reject(new Error('cart')))
      .then((cart)=>updateFromCart(cart,attention))
      .catch(()=>{});
    };

    if(bar){
      bar.addEventListener('click',(event)=>{
        event.preventDefault();
        setOpen(!panel.classList.contains('is-open'));
      });
    }

    if(collapse){
      collapse.addEventListener('click',(event)=>{
        event.preventDefault();
        window.PatikassoAnalytics?.track?.('cart_offer_collapsed','cart',{});
        setOpen(false);
      });
    }

    if(apply){
      apply.addEventListener('click',(event)=>{
        event.preventDefault();
        if(experimentControl()||campaignActive()||panel.dataset.patikassoFirstOrderEligible==='false'||apply.disabled)return;

        try{sessionStorage.setItem(CART_COMMITTED_KEY,'1')}catch(e){}
        window.PatikassoAnalytics?.tagCart?.();
        window.PatikassoAnalytics?.track?.('cart_offer_applied','cart',{code:'PATIKASSOILK10'});
        window.PatikassoAnalytics?.track?.('cart_offer_checkout_clicked','cart',{code:'PATIKASSOILK10'});

        panel.classList.remove('is-price-animating');
        void panel.offsetWidth;
        panel.classList.add('is-price-animating');
        apply.classList.add('is-loading');

        const main=apply.querySelector('.patikasso-cart-conversion__apply-main');
        const sub=apply.querySelector('.patikasso-cart-conversion__apply-sub');
        if(main)main.textContent='%10 İndirim Uygulanıyor';
        if(sub)sub.textContent='indirimli ödeme adımına geçiliyor…';

        setTimeout(()=>{
          window.location.href='/discount/PATIKASSOILK10?redirect=/checkout';
        },620);
      });
    }

    panel.addEventListener('click',(event)=>{
      const removeButton=event.target.closest('[data-cart-line-key]');
      if(!removeButton)return;

      event.preventDefault();
      event.stopPropagation();

      const key=removeButton.dataset.cartLineKey;
      if(!key)return;

      const card=removeButton.closest('.patikasso-cart-conversion__cart-item');
      card?.classList.add('is-removing');
      removeButton.disabled=true;

      const endpoint=(window.routes&&window.routes.cart_change_url)?window.routes.cart_change_url:'/cart/change.js';

      fetch(endpoint,{
        method:'POST',
        credentials:'same-origin',
        headers:{
          'Content-Type':'application/json',
          Accept:'application/json'
        },
        body:JSON.stringify({
          id:key,
          quantity:0,
          sections:'cart-icon-bubble',
          sections_url:window.location.pathname
        })
      })
      .then((response)=>response.ok?response.json():Promise.reject(new Error('change')))
      .then((cart)=>{
        const bubble=document.getElementById('cart-icon-bubble');
        const bubbleHtml=cart.sections?.['cart-icon-bubble'];
        if(bubble&&bubbleHtml){
          const doc=new DOMParser().parseFromString(bubbleHtml,'text/html');
          const fresh=doc.getElementById('cart-icon-bubble');
          if(fresh)bubble.innerHTML=fresh.innerHTML;
        }
        lastAddedVariantId=null;
        updateFromCart(cart,false);
      })
      .catch(()=>{
        card?.classList.remove('is-removing');
        removeButton.disabled=false;
      });
    });

    document.addEventListener('click',(event)=>{
      if(panel.classList.contains('is-open')&&!panel.contains(event.target)){
        setOpen(false);
      }
    });

    document.addEventListener('keydown',(event)=>{
      if(event.key==='Escape')setOpen(false);
    });

    document.addEventListener('patikasso:campaign-state',(event)=>{
      const active=!!event?.detail?.active;
      if(active){
        pauseForCampaign();
        setVisible(false);
      }else{
        resetOfferButton();
        setTimeout(()=>refreshCart(false),80);
      }
    });

    document.addEventListener('patikasso:cart-added',(event)=>{
      lastAddedVariantId=event?.detail?.variantId||null;
      setTimeout(()=>refreshCart(true),40);
    });

    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{
        setTimeout(()=>refreshCart(false),80);
      });
    }

    let widgetObserverTimer;
    const widgetObserver=new MutationObserver(()=>{
      if(!panel.classList.contains('is-visible'))return;
      clearTimeout(widgetObserverTimer);
      widgetObserverTimer=setTimeout(()=>manageExternalWidgets(true),280);
    });
    widgetObserver.observe(document.body,{childList:true,subtree:true});

    document.addEventListener('DOMContentLoaded',()=>refreshCart(false),{once:true});
    refreshCart(false);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["patikasso-product-hotspots"] && !Shopify.designMode) return;
  try {
    if(!window.PatikassoCompactReady){
  window.PatikassoCompactReady=true;

  const closeCompact=(wrap)=>{
    if(!wrap)return;
    wrap.classList.remove('is-open');
    const trigger=wrap.querySelector('.patikasso-compact__trigger');
    const panel=wrap.querySelector('.patikasso-compact__panel');
    if(trigger)trigger.setAttribute('aria-expanded','false');
    if(panel)panel.setAttribute('aria-hidden','true');
  };

  document.addEventListener('click',(event)=>{
    const trigger=event.target.closest('.patikasso-compact__trigger');

    if(trigger){
      event.preventDefault();
      event.stopPropagation();

      const wrap=trigger.closest('[data-patikasso-compact]');
      const panel=wrap.querySelector('.patikasso-compact__panel');
      const open=!wrap.classList.contains('is-open');

      document.querySelectorAll('[data-patikasso-compact].is-open').forEach((other)=>{
        if(other!==wrap)closeCompact(other);
      });

      wrap.classList.toggle('is-open',open);
      trigger.setAttribute('aria-expanded',open?'true':'false');
      if(panel)panel.setAttribute('aria-hidden',open?'false':'true');
      return;
    }

    document.querySelectorAll('[data-patikasso-compact].is-open').forEach((wrap)=>{
      if(!wrap.contains(event.target))closeCompact(wrap);
    });
  },true);

  document.addEventListener('keydown',(event)=>{
    if(event.key==='Escape'){
      document.querySelectorAll('[data-patikasso-compact].is-open').forEach(closeCompact);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
